function updateHeaderScrollOffset(headerElement) {
  const rootElement = document.documentElement;
  const rootStyles = window.getComputedStyle(rootElement);
  const gap = Number.parseFloat(rootStyles.getPropertyValue("--scroll-offset-gap")) || 0;
  const headerHeight = Math.ceil(headerElement.getBoundingClientRect().height);

  rootElement.style.setProperty("--scroll-offset-header", `${headerHeight + gap}px`);
}

export default function initHeaderScrollOffset() {
  const headerElement = document.getElementById("js-header");
  if (!headerElement) return;

  const syncHeaderScrollOffset = () => {
    window.requestAnimationFrame(() => {
      updateHeaderScrollOffset(headerElement);
    });
  };

  syncHeaderScrollOffset();
  window.addEventListener("load", syncHeaderScrollOffset, { once: true });
  window.addEventListener("resize", syncHeaderScrollOffset, { passive: true });

  if (!("ResizeObserver" in window)) return;

  const resizeObserver = new ResizeObserver(() => {
    syncHeaderScrollOffset();
  });

  resizeObserver.observe(headerElement);
}
